/**
 * There will be one reducer file per page / common component
 */
import {
    GET_VIEWFILTER_SUCCESS,
    GET_VIEWFILTER_FAILURE,
    GET_VIEWFILTER,
} from '../actions';

const initialState = {
    basicFilters: [],
    salesHierarchies: [],
    statusCode: 0,
    statusMessage: '',
};

const ViewFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_VIEWFILTER:
            return {
                ...state,
            };
        case GET_VIEWFILTER_SUCCESS: {
            const {
                basicFilters,
                salesHierarchies,
                statusCode,
                statusMessage,
            } = action.data;
            return {
                ...state,
                basicFilters: basicFilters,
                salesHierarchies: salesHierarchies,
                statusCode: statusCode,
                statusMessage: statusMessage,
            };
        }
        case GET_VIEWFILTER_FAILURE:
            return {
                ...state,
                basicFilters: [],
                salesHierarchies: [],
                statusCode: 0,
                statusMessage: '',
            };
        default: {
            return { ...state };
        }
    }
};

export default ViewFilterReducer;
